import { render, staticRenderFns } from "./BusinessScopeDocuments.vue?vue&type=template&id=ee81bc86&"
import script from "./BusinessScopeDocuments.vue?vue&type=script&lang=js&"
export * from "./BusinessScopeDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports